import { immerable } from 'immer';

export enum LanguagePreference {
	Browser = 'browser',
	Fr = 'fr',
	En = 'en',
}

type DateFormat = {
	DateTime: string;
	Date: string;
	Time: string;
};

const DAYJS_FORMATS: Record<string, DateFormat> = {
	fr: {
		DateTime: 'DD/MM/YYYY HH:mm',
		Date: 'DD/MM/YYYY',
		Time: 'HH:mm:ss',
	},
	en: {
		DateTime: 'MM/DD/YYYY hh:mm A',
		Date: 'MM/DD/YYYY',
		Time: 'hh:mm:ss A',
	},
};

interface IPreferences {
	language: LanguagePreference;
	dateFormat: DateFormat;
}

const entityDefaults: IPreferences = {
	language: LanguagePreference.Fr,
	dateFormat: DAYJS_FORMATS['fr'],
};

export class Preferences implements IPreferences {
	private [immerable] = true;
	public language = entityDefaults.language;
	public dateFormat = entityDefaults.dateFormat;

	public static build(params: Partial<IPreferences> = {}): Preferences {
		const instance = new Preferences();
		instance.language = params.language ?? entityDefaults.language;

		switch (params.language) {
			case LanguagePreference.En:
				instance.dateFormat = DAYJS_FORMATS['en'];
				break;
			case LanguagePreference.Fr:
				instance.dateFormat = DAYJS_FORMATS['fr'];
				break;
			case LanguagePreference.Browser: {
				const lang: string =
					navigator.language || (navigator as any).userLanguage;

				if (lang === 'fr-FR' || lang === 'fr') {
					instance.dateFormat = DAYJS_FORMATS['fr'];
					break;
				}
				if (lang === 'en-US' || lang === 'en') {
					instance.dateFormat = DAYJS_FORMATS['en'];
					break;
				}
				break;
			}
		}

		return instance;
	}
}
